<app-bread-crumb [items]="[{text:  'parcerias',link:'/admin/partnership'},{text:pageTitle}]"
    [sectionTitle]="pageTitle"></app-bread-crumb>

<section class="content">

    <!-- inicio do formulário -->
    <form [formGroup]="objectForm" novalidate (ngSubmit)="submitForm()">

        <!-- inicio do box -->
        <ng-box [boxIcon]="'fa fa-link'" [boxTitle]="'Dados da Parceria'" [showBoxFooter]="true">

            <!-- cabesalho do box -->
            <ng-container class="ng-box-header">
                <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}">
                </ng-button>
            </ng-container>

            <!-- inicio do conteudo do box -->
            <ng-container class="ng-box-content">

                <div class="row">

                    <div class="col-md-4">
          
                      <div class="form-group">
          
                        <app-input label="Parceiro(*)" errorMessage="Campo obrigatório">
          
                          <select formControlName="partners_id" class="form-control" #iptPatner (change)="setServicesOfPartner(iptPatner.value)">
                              <option selected value="">Selecione o Parceiro</option>
                              <option *ngFor="let partner of partners"  [value]="partner.id">{{ partner.name }}</option>
                          </select>
          
                        </app-input>
          
                      </div>
          
                    </div>

                    <div class="col-md-4">
          
                      <div class="form-group">
          
                        <app-input label="Serviço(*)" errorMessage="Campo obrigatório">
          
                          <select formControlName="services_id" class="form-control">
                             <option value="">Escolha o serviço</option>
                              <option *ngFor="let service of services" [value]="service.id">{{ service.name }}</option>
                          </select>
          
                        </app-input>
          
                      </div>
          
                    </div>
                    <div class="col-md-4">
          
                      <div class="form-group">
          
                        <app-input label="Clube(*)" errorMessage="Campo obrigatório">
          
                          <select formControlName="clubs_id" class="form-control">
                            <option value="">Selecione o Clube</option>
                            <option *ngFor="let club of clubs" [value]="club.id">{{ club.name }}</option>
                          </select>
          
                        </app-input>
          
                      </div>
          
                    </div>
          
                  </div>
          
                  <div class="row">
              
                    <div class="col-md-12">
          
                      <div class="form-group">
          
                        <app-input label="Descrição" errorMessage="Campo obrigatório">
                         <textarea formControlName="destription" class="form-control" cols="30" rows="4"></textarea>
                        </app-input>
          
                      </div>
          
                    </div>
          
                  </div>

            </ng-container>

            <!-- fim do conteudo do box -->

            <!-- inicio do rodapé -->
            <ng-container class="ng-box-footer">
                <div class="row">
                    <div class="col-xs-12">
                        <ng-button *ngIf="isAdmin()" class="pull-right" [button]="{
                            name:'salvar',
                            color:'danger',
                            faIconClass:'fa fa-save',
                            type:'submit',
                            loadingText:'SALVANDO',
                            isLoading:isButtonLoading,
                            isDisabled:isButtonLoading || objectForm.invalid}">
                        </ng-button>
                    </div>
                </div>
            </ng-container>
            <!-- fim do rodapé -->

        </ng-box>
        <!-- fim do box -->
    </form>
    <!-- fim do formulário -->
</section>